import { createAction } from "typesafe-actions";
import { domain } from "./types.js";
const getRealtimeActions = () => ({
  subscribe: createAction(`${domain}/subscribe`)(),
  unsubscribe: createAction(`${domain}/unsubscribe`)(),
  saveSubscriber: createAction(`${domain}/saveSubscriber`)(),
  removeSubscriber: createAction(`${domain}/removeSubscriber`)(),
  event: createAction(
    `${domain}/event`,
    (payload) => ({ ...payload, receivedAtTimestamp: Date.now() })
  )(),
  saveUpdatedViews: createAction(`${domain}/saveUpdatedViews`)(),
  cleanUpdatedViews: createAction(`${domain}/cleanUpdatedViews`)(),
  updateViews: createAction(`${domain}/updateViews`)(),
  pause: createAction(`${domain}/pause`)(),
  resume: createAction(`${domain}/resume`)()
});
export {
  getRealtimeActions
};
//# sourceMappingURL=actions.js.map
